/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Error_Lastname_Required1Inputs */

const es_co2_signup_error_lastname_required1 = /** @type {(inputs: Signup_Error_Lastname_Required1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El apellido es obligatorio`)
};

/**

* @param {Signup_Error_Lastname_Required1Inputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
const signup_error_lastname_required1 = /** @type {((inputs?: Signup_Error_Lastname_Required1Inputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Error_Lastname_Required1Inputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_signup_error_lastname_required1(inputs)
});
export { signup_error_lastname_required1 as "signup_error_lastName_required" }